import React, { useCallback, useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import "../../App.css";
import ShowSlider from "./ReportIncidentsShowSlider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClose,
  faCompress,
  faExpand,
} from "@fortawesome/free-solid-svg-icons";
import TypingDots from "../../animations/TypingDots";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ChatLayer from "./ChatLayer";
import { ResizableBox } from "react-resizable";
import PopUpWindowChat from "../../chat/PopUpWindowChat";
import { map } from "../MainLayer";
import { useHzContext } from "../../provider/HzProvider";
import { Coordinate } from "ol/coordinate";
import Overlay from "ol/Overlay";
import { HzSidebarMap, openWindowsHzMap } from "./IncidentsMenuDropDown";

interface Props {
  incidentId: string;
  adm4_en: string | null;
  bwater_level: string | null;
  end_time: string | null;
  hwater_level: string | null;
  img_url: string | null;
  imp_communication: string | null;
  imp_electricity: string | null;
  imp_house: string | null;
  imp_human: string | null;
  imp_response: string | null;
  imp_roadblock: string | null;
  imp_roaddamage: string | null;
  imp_water: string | null;
  impdes_communication: string | null;
  impdes_electricity: string | null;
  impdes_house: string | null;
  impdes_human: string | null;
  impdes_roadblock: string | null;
  impdes_roaddamage: string | null;
  impdes_water: string | null;
  issued_time: string | null;
  occurance_date: string | null;
  observed_date: string | null;
  tp_number: string | null;
  w_desc: string | null;
  w_name: string | null;
  w_type: string | null;
  onClose: (incidentId: string) => void;
  addItem?: (id: string, type: "ew" | "river" | "air" | "hz" | "rain") => void;
  id?: string;
}

const ReportIncidentPopUp: React.FC<Props> = ({
  incidentId,
  adm4_en,
  bwater_level,
  end_time,
  hwater_level,
  img_url,
  imp_communication,
  imp_electricity,
  imp_house,
  imp_human,
  imp_response,
  imp_roadblock,
  imp_roaddamage,
  imp_water,
  impdes_communication,
  impdes_electricity,
  impdes_house,
  impdes_human,
  impdes_roadblock,
  impdes_roaddamage,
  impdes_water,
  issued_time,
  occurance_date,
  observed_date,
  tp_number,
  w_desc,
  w_name,
  w_type,
  onClose,
  addItem,
  id,
}) => {
  const [showDialog, setShowDialog] = useState<boolean>(true);
  const [value, setValue] = useState<string>("1");
  const [showChat, setShowChat] = useState<boolean>(false);
  const [activeFullScreen, setActiveFullScreen] = useState<boolean>(false);
  const fullscreenModal = useRef<HTMLDivElement | null>(null);
  const [dimensions, setDimensions] = useState({
    resizableBoxwidth: 0,
    resizableBoxheight: 0,
  });

  const [dimensionsMin, setDimensionsMin] = useState({
    resizableBoxMinwidth: 0,
    resizableBoxMinheight: 0,
  });

  //----------------resibleBox Function----------------

  const updateDimensions = () => {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    // setDimensions({
    //   resizableBoxwidth: vw * 0.68,
    //   resizableBoxheight: vh * 0.78,
    // });
    // setDimensionsMin({
    //   resizableBoxMinwidth: vw * 0.3,
    //   resizableBoxMinheight: vh * 0.4,
    // });
    if (vw > 2000 && vh > 1200) {
      setDimensions({
        resizableBoxwidth: vw * 0.4,
        resizableBoxheight: vh * 0.3,
      });
    } else {
      setDimensions({
        resizableBoxwidth: vw * 0.3,
        resizableBoxheight: vh * 0.6,
      });
    }

    if (vw > 2000 && vh > 1200) {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.2,
        resizableBoxMinheight: vh * 0.3,
      });
    } else {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.3,
        resizableBoxMinheight: vh * 0.4,
      });
    }
  };

  useEffect(() => {
    updateDimensions();

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const openContentFullscreen = () => {
    if (!document.fullscreenElement) {
      enterFullscreen();
    } else {
      exitFullScreen();
    }
  };

  const enterFullscreen = () => {
    const elem = fullscreenModal.current;
    if (elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
      setActiveFullScreen(true);
    }
  };

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
    setActiveFullScreen(false);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const toggleChat = () => {
    setShowChat((prevShowChat) => !prevShowChat);
  };

  const closePopup = (incId: string) => {
    setShowDialog(false);
    onClose(incidentId);
    openWindowsHzMap.set(incId, "close");

    if (HzSidebarMap.has(incId)) {
      HzSidebarMap.delete(incId);
    }

    removeOverlay(incidentId);
    const entries = Array.from(HzSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  };

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";
    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const [selectTab, setSelectTab] = useState<string>("popupTabDetails");

  const popupRef = useRef<HTMLDivElement | null>(null);
  const enteredRef = useRef<boolean>(false);

  const mouseMoveEvent = useCallback((event: MouseEvent) => {
    const sideMenu = document.getElementById("side-menu-wrapper");

    if (sideMenu && !enteredRef.current) {
      const sideMenuWidth = sideMenu.getBoundingClientRect();
      const sideMenuLeft = sideMenuWidth.left;

      if (sideMenuLeft < event.clientX) {
        enteredRef.current = true;
        if (id && addItem) {
          addItem(id, "hz");
          /* props.windowState(false) */
          setShowDialog(false);
        }
      }
    }
  }, []);

  const touchMoveEvent = useCallback((event: TouchEvent) => {
    const sideMenu = document.getElementById("side-menu-wrapper");

    if (sideMenu && !enteredRef.current) {
      const sideMenuWidth = sideMenu.getBoundingClientRect();
      const sideMenuLeft = sideMenuWidth.left;

      const touchX = event.touches[0].clientX;

      if (sideMenuLeft < touchX) {
        enteredRef.current = true;
        if (id && addItem) {
          addItem(id, "hz");
          /* props.windowState(false) */
          setShowDialog(false);
        }
      }
    }
  }, []);

  useEffect(() => {
    const handleMouseDown = () => {
      document.addEventListener("mousemove", mouseMoveEvent);
      document.addEventListener("mouseup", handleMouseUp);
    };

    const handleTouchStart = () => {
      document.addEventListener("touchmove", touchMoveEvent);
      document.addEventListener("touchend", handleTouchEnd);
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", mouseMoveEvent);
    };

    const handleTouchEnd = () => {
      document.removeEventListener("touchmove", touchMoveEvent);
    };

    if (popupRef.current) {
      popupRef.current.addEventListener("mouseenter", () => {
        popupRef.current?.addEventListener("mousedown", handleMouseDown);
        popupRef.current?.addEventListener("touchstart", handleTouchStart);
      });
    }

    return () => {
      document.removeEventListener("mousemove", mouseMoveEvent);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("touchmove", touchMoveEvent);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, [mouseMoveEvent, touchMoveEvent]);

  return (
    <div
      className="ol-overlay-container ol-selectable"
      style={{
        width: "10px",
        height: "10px",
      }}
    >
      <div
        style={{ visibility: showDialog ? "visible" : "hidden", width: "0%" }}
      >
        <Draggable handle=".drag-handle" enableUserSelectHack={false}>
          <ResizableBox
            className="custom-resizable-box"
            width={dimensions.resizableBoxwidth}
            height={dimensions.resizableBoxheight}
            minConstraints={[
              dimensionsMin.resizableBoxMinwidth,
              dimensionsMin.resizableBoxMinheight,
            ]}
            /* maxConstraints={[800, 600]} */
            resizeHandles={["s", "se", "sw", "ne", "nw"]}
            style={{ zIndex: 1, left: "-30vw", right: "0vw", top: "-40vh" }}
          >
            <div
              className="drag-handle"
              ref={fullscreenModal}
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                cursor: "move",
                touchAction: "none",
              }}
            >
              <div className="Mainpopup">
                <div className="popup">
                  <div className="popupBoxContainer" ref={popupRef}>
                    {/* Popup title container */}
                    <section className="titleContainer">
                      {/* Popup title */}
                      <span>reported incidents</span>
                      {/* Popup title button container */}
                      <div className="titleButtonContainer">
                        <div
                          className="titleIcon fullscreenIco"
                          onClick={openContentFullscreen}
                          onTouchStart={openContentFullscreen}
                        ></div>
                        <div
                          className="titleIcon closeIco"
                          onClick={() => closePopup(incidentId)}
                          onTouchEnd={() => closePopup(incidentId)}
                        ></div>
                      </div>
                    </section>
                    {/* Popup tab selector */}
                    <section className={"tabSelector"}>
                      <span
                        className={`tabButton ${
                          selectTab === "popupTabDetails" ? "tabSelected" : ""
                        }`}
                        onClick={(e) => setSelectTab("popupTabDetails")}
                        onTouchStart={(e) => setSelectTab("popupTabDetails")}
                      >
                        details
                      </span>
                      <span
                        className={`tabButton ${
                          selectTab === "popupTabForecast" ? "tabSelected" : ""
                        }`}
                        onClick={(e) => setSelectTab("popupTabForecast")}
                        onTouchStart={(e) => setSelectTab("popupTabForecast")}
                      >
                        forecast
                      </span>
                      <span
                        className={`tabButton ${
                          selectTab === "popupTab3DTerrain" ? "tabSelected" : ""
                        }`}
                        onClick={(e) => setSelectTab("popupTab3DTerrain")}
                        onTouchStart={(e) => setSelectTab("popupTab3DTerrain")}
                      >
                        3D terrain
                      </span>
                    </section>
                    {/* Popup tab data containers */}
                    <section className="tabsDataContainer">
                      {/* Details tab data */}
                      <div
                        className={`tabDataContainer detailsTabContainer ${
                          selectTab === "popupTabDetails" ? "tabOpen" : ""
                        }`}
                      >
                        {/* Left side */}
                        <div className="detailsTabContainerLeft">
                          {/* Details container */}
                          <div className="detailsContainer">
                            <span className="title">{w_name}</span>
                            <div className="dataContainer">
                              <div className="dataRow">
                                <span className="name">Description</span>
                                <span className="data">{w_desc}</span>
                              </div>
                              <div className="dataRow">
                                <span className="name">
                                  Grama Niladari Devision
                                </span>
                                <span className="data"> {adm4_en}</span>
                              </div>
                              <div className="dataRow">
                                <span className="name">Date</span>
                                <span className="data">{issued_time}</span>
                              </div>
                              <div className="dataRow">
                                <span className="name"> Occurrence date</span>
                                <span className="data">{occurance_date}</span>
                              </div>
                              <div className="dataRow">
                                <span className="name">Observed date</span>
                                <span className="data">{observed_date}</span>
                              </div>
                              <div className="dataRow">
                                <span className="name">Telephone number</span>
                                <span className="data">{tp_number}</span>
                              </div>
                              <div className="dataRow">
                                <span className="name"> People affected</span>
                                <span className="data">{imp_human}</span>
                              </div>
                              {impdes_human && (
                                <div className="dataRow">
                                  <span className="name">More description</span>
                                  <span className="data">{impdes_human}</span>
                                </div>
                              )}

                              <div className="dataRow">
                                <span className="name">House damaged</span>
                                <span className="data">{imp_house}</span>
                              </div>
                              {impdes_house && (
                                <div className="dataRow">
                                  <span className="name">More description</span>
                                  <span className="data">{impdes_house}</span>
                                </div>
                              )}
                              <div className="dataRow">
                                <span className="name">Road blocks</span>
                                <span className="data">{imp_roadblock}</span>
                              </div>
                              {impdes_roadblock && (
                                <div className="dataRow">
                                  <span className="name">More description</span>
                                  <span className="data">
                                    {impdes_roadblock}
                                  </span>
                                </div>
                              )}
                              <div className="dataRow">
                                <span className="name">Road damages</span>
                                <span className="data"> {imp_roaddamage}</span>
                              </div>
                              {impdes_roaddamage && (
                                <div className="dataRow">
                                  <span className="name">More description</span>
                                  <span className="data">
                                    {impdes_roaddamage}
                                  </span>
                                </div>
                              )}
                              <div className="dataRow">
                                <span className="name">
                                  Electricity supply failure
                                </span>
                                <span className="data">{imp_electricity}</span>
                              </div>
                              {impdes_electricity && (
                                <div className="dataRow">
                                  <span className="name">More description</span>
                                  <span className="data">
                                    {impdes_electricity}
                                  </span>
                                </div>
                              )}
                              <div className="dataRow">
                                <span className="name">
                                  Water supply failure
                                </span>
                                <span className="data">{imp_water}</span>
                              </div>
                              {impdes_water && (
                                <div className="dataRow">
                                  <span className="name">More description</span>
                                  <span className="data">{impdes_water}</span>
                                </div>
                              )}
                              <div className="dataRow">
                                <span className="name">
                                  Communication supply failure
                                </span>
                                <span className="data">
                                  {imp_communication}
                                </span>
                              </div>
                              {impdes_communication && (
                                <div className="dataRow">
                                  <span className="name">More description</span>
                                  <span className="data">
                                    {impdes_communication}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          {/* Comment section */}
                          <div className="commentContainer">
                            <span className="title">{w_name}</span>
                            <PopUpWindowChat w_id={incidentId} />
                          </div>
                        </div>
                        <div className="detailsTabContainerRight">
                          <ShowSlider img_url={img_url} w_id={incidentId} />
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </ResizableBox>
        </Draggable>
      </div>
    </div>
  );
};

export default ReportIncidentPopUp;
